import React from "react";

const FeedBackBot = () => {
  return (
    <div className="mt-3 flex items-center justify-start md:justify-center">
      <p className="w-1/2 leading-4">
        Get unlimited doubt solving and live interview feedback anytime with
        Ninja bot.
      </p>
      <div className="h-[233px] w-[153px]">
        <img
          src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/ezgif.com-optimize.gif?updatedAt=1686638228154"
          className="h-full w-full rounded-xl object-fill"
        />
      </div>
    </div>
  );
};

export default FeedBackBot;
